import { useEffect, useState } from "react";
import { publicApi } from "@/lib/api";
import { fmtDT } from "@/lib/brand";
import { Stars } from "@/components/site/Stars";

export function CarReviews({ carId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    publicApi.get(`/cars/${carId}/reviews`).then((r) => setData(r.data)).catch(() => setData({ reviews: [], rating_count: 0 }));
  }, [carId]);
  if (!data) return null;
  return (
    <section data-testid="car-reviews">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <h2 className="text-2xl font-semibold tracking-tight">Customer reviews</h2>
        {data.rating_count > 0 && (
          <p className="flex items-center gap-2" data-testid="car-reviews-summary">
            <span className="text-2xl font-bold">{data.rating_avg.toFixed(1)}</span><Stars value={data.rating_avg} />
            <span className="text-sm text-neutral-500">{data.rating_count} review{data.rating_count > 1 ? "s" : ""}</span>
          </p>
        )}
      </div>
      {data.reviews.length === 0
        ? <p className="mt-4 rounded-2xl border border-dashed border-black/10 bg-white p-6 text-sm text-neutral-500" data-testid="car-reviews-empty">No reviews yet. Reviews come from customers who completed a trip in this car.</p>
        : (
          <div className="mt-5 grid gap-4 sm:grid-cols-2">
            {data.reviews.map((r) => (
              <div key={r.id} className="rounded-2xl border border-black/5 bg-white p-5" data-testid={`car-review-${r.id}`}>
                <div className="flex items-center justify-between gap-2">
                  <p className="font-semibold">{r.name}</p><Stars value={r.rating} />
                </div>
                {r.comment && <p className="mt-2 text-sm leading-6 text-neutral-700">{r.comment}</p>}
                <p className="mt-3 text-xs text-neutral-400">{fmtDT(r.created_at)}</p>
              </div>
            ))}
          </div>
        )}
    </section>
  );
}
